import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { NEVER, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserAccountInfo } from '../models/user-account-info.model';
import { DeficienciesService } from '../services/sections/deficiencies/deficiencies.service';
import { GlobalSettingsService } from '../services/ui/global-settings.service';

@Injectable({
  providedIn: 'root'
})
export class DeficienciesAccountInfoResolver implements Resolve<UserAccountInfo> {
  constructor(
    private router: Router,
    private deficienciesService: DeficienciesService
  ) { }
  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {
    
    GlobalSettingsService.isSecondaryLoaderLoading = true;

    return this.deficienciesService.getUserAccountInfo(activatedRouteSnapshot.paramMap.get('token'))
      .pipe(
        catchError(() => {
          this.router.navigate(['/404']);
          GlobalSettingsService.isSecondaryLoaderLoading = false;
          return NEVER;
        })
      )
  }
}
